module.exports = __webpack_public_path__ + "static/media/nextPage.7c70c46c.svg";